import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SavePostInstallCallScriptParams } from "../types/SavePostInstallCallScriptFormParams";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";

export const useSavePostInstallCallScriptForm = (
	params: SavePostInstallCallScriptParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-postInstallForm';
	requestParams = {
		RetailOrderID: params.formObject.RetailOrderID,
		RetailOrderNo: params.formObject.RetailOrderNo,
		AnyProblemCheckBox: params.formObject.AnyProblemCheckBox,
		AskCustomerCheckBox: params.formObject.AskCustomerCheckBox,
		CongratulateCheckBox: params.formObject.CongratulateCheckBox,
		FinishedPicturesCheckBox: params.formObject.FinishedPicturesCheckBox,
		IfNoCheckBox: params.formObject.IfNoCheckBox,
		IfYesCheckBox: params.formObject.IfYesCheckBox,
		LastChanceCheckBox: params.formObject.LastChanceCheckBox,
		LowesSurveyPerfectCheckBox: params.formObject.LowesSurveyPerfectCheckBox,
		OfferCheckBox: params.formObject.OfferCheckBox,
		ThankCheckBox: params.formObject.ThankCheckBox,
		BrieflyExplainText: params.formObject.BrieflyExplainText,
		MayISpeakToCheckBox: params.formObject.MayISpeakToCheckBox,
		IntroduceYourselfCheckBox:  params.formObject.IntroduceYourselfCheckBox,
		NoteText: params.formObject.NoteText
	};

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)	
				onSuccess(result);
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}